/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog, DialogActions } from "@mui/material";
import { Modal, Alert } from "react-bootstrap";
import { BASE_URL } from "../../utils/config";
import UploadIcon from "@mui/icons-material/Upload";
import SessionLogout from "../../components/animation/sessionLogout";

import IconPDF from "../../assets/images/icon-pdf.png";
import api from "../../utils/api";
import axios from "axios";

import "../../style/learn-rkb.css";
import "../../style/mob-learn-rkb.css";
import "../../style/OtpVerification.css";
import "../../style/NewDashBoard.css";
import "../../../src/App.css"

import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CloseIcon from "@mui/icons-material/Close";

/* -------------------- TYPES -------------------- */
type MonthPerformance = {
  id: number;
  months: string;
  Years: number;
  PL: number;
};

type YearPerformance = {
  years: number;
  PL: number;
  json_data: string;
};

const performanceApiMap: Record<string, string> = {
  Option: "Option",
  IntraDay: "Intraday",
  Future: "Future",
  Commodity: "Commodity",
  Mentorship: "Mentorship",
};

const userData = JSON.parse(localStorage.getItem("userData") || "{}");
const isAdmin = userData?.isAdmin;
  // userData?.usertype === "admin" ||
  // userData?.usertype === "ADMIN" ||
  // userData?.usertype_id === 1; // adjust if numeric

/* ==================== COMPONENT ==================== */
const LearnRkbHome: React.FC = () => {
  const navigate = useNavigate();

  /* -------------------- BASIC STATE -------------------- */
  const currentYear = new Date().getFullYear();
    const currentMonth = new Date().toLocaleString('default', { month: 'long' });
    const [months, setMonths] = useState([]);
    const [years, setYears] = useState([]);
    const allMonths = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
  const [userdetails, setUserDetails] = useState<any>({});
  const [loading, setLoading] = useState(false);
   const [sessionExpired, setSessionExpired] = useState(false)

  /* -------------------- TAB STATE -------------------- */
  const tabs = [
  { id: 0, label: "Option", heading: "Option" },
  { id: 1, label: "IntraDay", heading: "Intraday" },
  { id: 2, label: "Future", heading: "Future" },
  { id: 3, label: "Commodity", heading: "Commodity" },
  { id: 4, label: "Mentorship", heading: "Mentorship" },
];

const [activeTab, setActiveTab] = useState(
  tabs.find(t => t.label === "Option")!
);
  const [tabData, setTabData] = useState<YearPerformance[]>([]);
  const [expandedYears, setExpandedYears] = useState<number[]>([0]);

  /* -------------------- RENKO DATA -------------------- */
  // const [deliveryTabs, setDeliveryTabs] = useState([
  //   { id: "delivery", data: [], previousClose: [] },
  // ]);


  /* -------------------- DELETE -------------------- */
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  /* -------------------- UPLOAD POPUP -------------------- */
const [CreateReport, setCreateReport] = useState(false);
const [messageDialog, setMessageDialog] = useState(false);
const [errorpopup, setErrorpopup] = useState(false);

/* -------------------- FORM STATE -------------------- */
const [performanceType, setPerformanceType] = useState("Option");
const [selectedYear, setSelectedYear] = useState(currentYear);
const [selectedMonth, setSelectedMonth] = useState(currentMonth);
const [profitLossAmount, setProfitLossAmount] = useState("");
const [exitPosition, setExitPosition] = useState("");
const [file, setFile] = useState<File | null>(null);
const [filePreview, setFilePreview] = useState("");
const isMentorship = activeTab.label === "Mentorship";

const fileInputRef = useRef<HTMLInputElement | null>(null);


const handleClose = () => setCreateReport(false);

const handleOpenFileManager = () => {
  fileInputRef.current?.click();
};

const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const uploadedFile = e.target.files?.[0];
  if (!uploadedFile) return;

  setFile(uploadedFile);
  setFilePreview(uploadedFile.name);
};

const handleRemoveFile = (e: React.MouseEvent) => {
  e.stopPropagation();
  setFile(null);
  setFilePreview("");
};


  useEffect(() => {
        // Set the last 5 years
        setYears(Array.from({ length: 5 }, (v, i) => currentYear - i));
    }, [currentYear]);

    useEffect(() => {
        if (selectedYear === currentYear) {
            // If the selected year is the current year, show months up to the current month
            const currentMonthIndex = allMonths.indexOf(currentMonth);
            setMonths(allMonths.slice(0, currentMonthIndex + 1));
        } else {
            // Otherwise, show all months
            setMonths(allMonths);
        }
    }, [selectedYear, currentMonth]);


// const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();

//   if (!performanceType || !selectedYear || !selectedMonth || !file) {
//     setErrorpopup(true);
//     return;
//   }

//   try {
//     const formData = new FormData();
//     formData.append("performanceType", performanceType);
//     formData.append("year", String(selectedYear));
//     formData.append("month", selectedMonth);
//     formData.append("PL", profitLossAmount);
//     formData.append("file", file);

//     await api.post("/createperformance", formData);

//     setCreateReport(false);
//     setShowSuccessMessage(true);
//     fetchPerformance(performanceApiMap[activeTab.label]);
//   } catch {
//     setShowErrorMessage(true);
//   }
// };



const handleSubmit = async (e) => {
        e.preventDefault();
        if (performanceType === 'Mentorship') {
            if (!performanceType || !selectedYear || !selectedMonth || !exitPosition || !file) {
                console.error("All fields are required.");
                setErrorpopup(true);
                setTimeout(() => {
                    setErrorpopup(false);
                }, 1500)
                return;
            }
        }
        else if (!performanceType || !selectedYear || !selectedMonth || !profitLossAmount || !file) {
            console.error("All fields are required.");
           
            setErrorpopup(true);
            setTimeout(() => {
                setErrorpopup(false);
            }, 1500)
            return;
        }

        const formData = new FormData();
        formData.append('performanceType', performanceType);
        formData.append('Year', selectedYear.toString());
        formData.append('Month', selectedMonth);
        formData.append('PL', profitLossAmount);
        if (performanceType === 'Mentorship') {
            formData.append('ExitPosition', exitPosition);
        }
        const UserData = JSON.parse(localStorage.getItem('userData'));
        const createdBy = UserData?._id;
        console.log("createdBy", createdBy);
        if (!createdBy) {
            console.error("[handleSubmit] No user ID found in userData:", UserData);
            setErrorMessage("User session is invalid. Please log in again.");
            setShowErrorMessage(true);
            setTimeout(() => { setShowErrorMessage(false); setErrorMessage(""); }, 2000);
            return;
        }
        formData.append('createdBy', createdBy);
        if (file) {
            formData.append('performanceFile', file);
        }


        try {
            const token = localStorage.getItem('AUTH_TOKEN');
            
            console.log("token", token);
            if (!token) {
                console.error("[handleSubmit] No AUTH_TOKEN found in localStorage. User may not be logged in.");
                setErrorMessage("Session not found. Please log in again.");
                setShowErrorMessage(true);
                setTimeout(() => { setShowErrorMessage(false); setErrorMessage(""); }, 2000);
                return;
            }
            console.log("[handleSubmit] Token found, submitting performance report...");
            const response = await axios.post(`${BASE_URL}/createperformance`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 200) {
                console.log('Report created successfully:', response.data);
                setErrorMessage("Uploaded performance report successfully");
                setShowSuccessMessage(true);
                    setTimeout(() => {
                        setShowSuccessMessage(false);
                        setErrorMessage("");
                        window.location.reload();
                    
                    }, 1500);
                
                handleClose(); // Close the dialog after successful submission
               
            } 
        } catch (error) {
            console.error('Error creating report:', error);
            if (axios.isAxiosError(error) && error.response) {
                console.log("error", error);

                if (error.response.status === 403) {
                    setLoading(false);
                    setSessionExpired(true)
                    setTimeout(() => {
                        setSessionExpired(false)
                        navigate('/login')
                    }, 5000)
                }
                else if (error.response.status === 401) {
                    setLoading(false);
                    setSessionExpired(true)
                    // setTimeout(() => {
                    //     setSessionExpired(false)
                    //     navigate('/login')
                    // }, 5000)
                }
                else if (error.response.status === 400) {
                    setLoading(false);
                    setErrorMessage("Failed to upload performance report");
                    setShowErrorMessage(true);
                    setTimeout(() => {
                        setShowErrorMessage(false);
                        setErrorMessage("");
                    }, 1500);
                }
                else {
                    setLoading(false);
                    setErrorMessage("Failed to upload performance report");
                    setShowErrorMessage(true);
                    setTimeout(() => {
                        setShowErrorMessage(false);
                        setErrorMessage("");
                    }, 1500);
                }

            } else {
                setLoading(false);
                setErrorMessage("Failed to upload performance report");
                setShowErrorMessage(true);
                setTimeout(() => {
                    setShowErrorMessage(false);
                    setErrorMessage("");
                }, 1500);
            }

        }
  };



  /* -------------------- INIT -------------------- */
  useEffect(() => {
    const details = JSON.parse(localStorage.getItem("userData") || "{}");
    setUserDetails(details);
  }, []);

  useEffect(() => {
  fetchPerformance(performanceApiMap[activeTab.label]);
}, []);


  /* -------------------- API CALLS -------------------- */
  const fetchPerformance = async (type: string) => {
    try {
      setLoading(true);
      const res = await api.get(`/getPerformance/${type}`);
      console.log("Performance API response:", res.data.performanceReport);
      setTabData(res.data.performanceReport || []);
    } catch (err: any) {
  if (err.response?.status === 403) {
    setErrorMessage("You are not authorized to view this data");
    setShowErrorMessage(true);
  }
  setTabData([]);
}
finally {
      setLoading(false); 
    }
  };

  // const fetchRenkoData = async () => {
  //   try {
  //     const res = await api.get(`/getAllReportList/delivery`);
  //     if (res.data.status === 200) {
  //       setDeliveryTabs([
  //         {
  //           id: "delivery",
  //           data: res.data.data,
  //           previousClose: [],
  //         },
  //       ]);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const fetchRenkoPreviousClose = async () => {
  //   try {
  //     const res = await api.get(`/previousclose/delivery`);
  //     if (res.data.success) {
  //       setDeliveryTabs((prev) => [
  //         {
  //           ...prev[0],
  //           previousClose: res.data.previousCloseData,
  //         },
  //       ]);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  /* -------------------- AUTO LOAD -------------------- */
  // useEffect(() => {
  //   if (firstLoadRef.current) {
  //     firstLoadRef.current = false;
  //     if (activeTab.label === "RenkoReport") {
  //       fetchRenkoData();
  //       fetchRenkoPreviousClose();
  //     } else {
  //       fetchPerformance(performanceApiMap[activeTab.label]);
  //     }
  //   }

  //   const interval = setInterval(() => {
  //     if (activeTab.label === "RenkoReport") {
  //       fetchRenkoData();
  //       fetchRenkoPreviousClose();
  //     } else {
  //       fetchPerformance(performanceApiMap[activeTab.label]);
  //     }
  //   }, 30000);

  //   return () => clearInterval(interval);
  // }, [activeTab]);

//   const location = useLocation();

// useEffect(() => {
//   if (!location.pathname.startsWith("/admin/learnrkb")) return;

//   fetchRenkoData();
//   fetchRenkoPreviousClose();
// }, [location.pathname]);


  /* -------------------- HANDLERS -------------------- */
  const toggleYear = (index: number) => {
    setExpandedYears((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handlePdfView = (row: any) => {
  if (!row?.id) {
    console.error("PDF ID missing", row);
    return;
  }

  navigate("/pdfReportView", { state: { id: row.id } });
};


  const handleDelete = async () => {
    try {
      await api.delete(`/deletePerformance/${selectedRow.id}`);
      setMessageDialog(false);
      fetchPerformance(performanceApiMap[activeTab.label]);
      setErrorMessage("Deleted successfully");
      setShowSuccessMessage(true);
    } catch {
      setErrorMessage("Delete failed");
      setShowErrorMessage(true);
    }
  };

  useEffect(() => {
  const fixTabs = () => {
    const nav = document.querySelector(
      ".p-tabview-nav"
    ) as HTMLElement | null;

    if (!nav) return;

    nav.style.width = "100%";
    nav.style.maxWidth = "100%";
    nav.style.overflowX = "auto";
    nav.style.overflowY = "hidden";
    nav.style.whiteSpace = "nowrap";

    const container = nav.closest(
      ".p-tabview-nav-container"
    ) as HTMLElement | null;

    if (container) {
      container.style.width = "100%";
      container.style.maxWidth = "100%";
      container.style.overflowX = "hidden";
    }
  };

  // 🔑 Run AFTER PrimeReact finishes layout
  requestAnimationFrame(() => {
    requestAnimationFrame(fixTabs);
  });
}, [activeTab]);


  /* -------------------- RENDER PERFORMANCE -------------------- */
  const renderPerformanceTabs = (unit: string, label: string) => {
    if (!tabData.length)
      return <div style={{ textAlign: "center" }}>Data not found</div>;

    return tabData.map((yearData, index) => (
      <div key={index} className="year-data">
        <div className="Year-div" onClick={() => toggleYear(index)}>
          <div className="year-row">
            {/* LEFT: Year + down arrow */}
            <h2 className="year-title">
              {yearData.years}
              {expandedYears.includes(index) ? (
                <i className="bi bi-chevron-up"></i>
              ) : (
                <i className="bi bi-chevron-down"></i>
              )}
            </h2>


            {/* RIGHT: P&L */}
            <div className="year-pl">
              <span className="pl-label">P&amp;L:</span>
              <span
                className={`pl-value ${yearData.PL < 0 ? "loss" : "profit"}`}
              >
            {isMentorship ? `${yearData.PL}%` : `₹${yearData.PL}`} 
            </span>
            </div>
          </div>
        </div>
        

        {expandedYears.includes(index) && (
          <div className="table-thumbnail">
              {(typeof yearData.json_data === 'string' ? JSON.parse(yearData.json_data) : yearData.json_data as MonthPerformance[]).map(
              (data, idx) => (
 
              <div className="thumbnail" key={idx}>
                <div className="thumb-left">
                  <span className="month-text">{data.months}</span>

                <div className="net-text">
                <span className="net-label">
                  {isMentorship ? "Average Returns -" : "Net Returns –"}
                </span>

                <span className={`pl-amount ${data.PL < 0 ? "loss" : "profit"}`}>
                  {isMentorship ? `${data.PL}%` : `₹${data.PL}`}
                </span>                  

                  <span className={`pl-icon ${data.PL < 0 ? "loss" : "profit"}`} />
                </div>
                  
                </div>

                <div className="thumb-actions">
                  <button onClick={() => handlePdfView(data)}>
                    <img src={IconPDF} alt="PDF" />
                  </button>

                  {isAdmin && (
                    <button
                      onClick={() => {
                        setSelectedRow(data);
                        setMessageDialog(true);
                      }}
                    >
                      <i className="pi pi-trash" />
                    </button>
                  )}
                </div>
              </div>    

              )
            )}
          </div>
        )}
      </div>
    ));
  };

  

  /* -------------------- RENDER -------------------- */
   if (loading) {
  return (
    
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    
  );
}

  return (

    <div className="Performance_Page">
      <div className="Preformance_Page_Heading">
        <h1>Performance Report</h1>
        {/* {userdetails?.usertype_id === 1 && ( */}
           {isAdmin && (
        <button
            className="btn-create"
            onClick={() => setCreateReport(true)}
        >
            <UploadIcon fontSize="small"/>
            Upload
        </button>
    )}
      </div>

      
      {/* {isAdmin && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px", marginRight: "50px" }}>
          <button style={{ backgroundColor: "#a7199b", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "4px", cursor: "pointer" }} className="btn-create" onClick={() => setCreateReport(true)}>
            <UploadIcon /> Upload
          </button>
 </div>
        )} */}


      <div className="performance-tabs">
        <TabView
          activeIndex={activeTab.id}
          onTabChange={(e) => {
            const selected = tabs[e.index];
            setActiveTab(selected);
            setExpandedYears([0]);

            // if (selected.label === "RenkoReport") {
            //   fetchRenkoData();
            //   fetchRenkoPreviousClose();
            // } else {
            //   fetchPerformance(performanceApiMap[selected.label]);
            // }
             fetchPerformance(performanceApiMap[selected.label]);
          }}
        >
          {/* <TabPanel header="Renko Report">
            <ScreenerTab
              Record={deliveryTabs[0].data}
              heading="Renko Report"
              updateSLchange={fetchRenkoData}
              PreviousClose={deliveryTabs[0].previousClose}
            />
          </TabPanel> */}

          <TabPanel header="Option">
            {renderPerformanceTabs("₹", "Net Returns")}
          </TabPanel>

          <TabPanel header="Intraday">
            {renderPerformanceTabs("₹", "Net Returns")}
          </TabPanel>

          <TabPanel header="Future">
            {renderPerformanceTabs("₹", "Net Returns")}
          </TabPanel>

          <TabPanel header="Commodity">
            {renderPerformanceTabs("₹", "Net Returns")}
          </TabPanel>

          <TabPanel header="Mentorship">
            {renderPerformanceTabs("%", "Average Returns")}
          </TabPanel>
        </TabView>
      </div>

      {/* ================= UPLOAD REPORT POPUP ================= */}
        <Dialog open={CreateReport} className="popup-createreport">
          <>
            <div className="CreateReport-Close">
              <i
                className="pi pi-times"
                onClick={handleClose}
                style={{ color: "#697565", cursor: "pointer" }}
              />
            </div>

            <div className="CreateReport_Page">
              <h1>Upload Report</h1>

              <form onSubmit={handleSubmit}>
                {/* Performance Type */}
                <div className="Report-inputgroup">
                  <label>
                    Performance Type:<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="inputfield"
                    required
                    value={performanceType}
                    onChange={(e) => setPerformanceType(e.target.value)}
                  >
                    <option value="Option">Option</option>
                    <option value="Intraday">Intraday</option>
                    <option value="Future">Future</option>
                    <option value="Commodity">Commodity</option>
                    <option value="Mentorship">Mentorship</option>
                  </select>
                </div>

                {/* Year */}
                <div className="Report-inputgroup">
                  <label>
                    Year:<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="inputfield"
                    required
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                  >
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Month */}
                <div className="Report-inputgroup">
                  <label>
                    Month:<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="inputfield"
                    required
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    {months.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Profit / Loss */}
                <div className="Report-inputgroup">
              <label>
                Profit / Loss Amount
                {performanceType === "Mentorship" && " (%)"}
                {performanceType !== "Mentorship" && <span style={{ color: "red" }}>*</span>}
              </label>
                  
                  <input
                    type="number"
                    className="inputfield"
                    value={profitLossAmount}
                    onChange={(e) => setProfitLossAmount(e.target.value)}
                    required={performanceType !== "Mentorship"}
                  />
                </div>

                {/* Exit Position (Mentorship only) */}
                {performanceType === "Mentorship" && (
                  <div className="Report-inputgroup">
                    <label>
                      Exit Position:<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="number"
                      className="inputfield"
                      value={exitPosition}
                      onChange={(e) => setExitPosition(e.target.value)}
                      required
                    />
                  </div>
                )}

                {/* File Upload */}
                <div className="Report-inputgroup">
                  <label>
                    File:<span style={{ color: "red" }}>*</span>
                  </label>

                <div
                  style={{
                    position: "relative",
                    width: "100%",         
                    height: "210px",
                    border: "1px dashed #b7a7e2",
                    borderRadius: "14px",
                    backgroundColor: "#EEE8FA",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    boxSizing: "border-box",
                  }}
                  onClick={handleOpenFileManager}
                >

                    {filePreview ? (
                      <>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            textAlign: "center",
                            padding: "0 16px",
                            wordBreak: "break-word",
                          }}
                        >
                          {filePreview}
                        </p>

                        <div
                          style={{ position: "absolute", top: "8px", right: "12px" }}
                          onClick={handleRemoveFile}
                        >
                          <CloseIcon />
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "10px",
                          textAlign: "center",
                          color: "#5b5b7a",
                        }}
                      >
                        <AddAPhotoIcon sx={{ fontSize: 34 }} />
                        <p
                          style={{
                            margin: 0,
                            fontSize: "15px",
                            fontWeight: 500,
                            lineHeight: "20px",
                          }}
                        >
                          Upload Performance file
                        </p>
                      </div>
                    )}
                  </div>
                  
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept="application/pdf"
                    required
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </div>

                <button type="submit" className="Button-Submit">
                  Submit
                </button>
              </form>
            </div>
          </>
        </Dialog>

        {/* ================= SUCCESS MESSAGE ================= */}
        <Modal show={showSuccessMessage} onHide={() => setShowSuccessMessage(false)}>
          <Alert variant="success">{errorMessage}</Alert>
        </Modal>

        {/* ================= ERROR MESSAGE ================= */}
        <Modal show={showErrorMessage} onHide={() => setShowErrorMessage(false)}>
          <Alert variant="danger">{errorMessage}</Alert>
        </Modal>

        {/* ================= DELETE CONFIRMATION ================= */}
        <Dialog open={messageDialog}>
          <div className="learnrkb-popup-one">
            <div className="CreateReport-Close">
              <i
                className="pi pi-times"
                onClick={() => setMessageDialog(false)}
                style={{ color: "#697565", cursor: "pointer" }}
              />
            </div>

            <div className="CreateReport_Page">
              <h1 style={{ color: "red" }}>Confirmation</h1>
              <p>Are you sure you want to delete this performance report?</p>
            </div>

            <DialogActions
          sx={{
            justifyContent: "center",
            gap: "8px",
            paddingBottom: "20px",
          }}
        >
          <Button
            label="No"
            outlined
            severity="secondary"
            onClick={() => setMessageDialog(false)}
            style={{
              minWidth: "60px",
              borderRadius: "8px",
            }}
          />

          <Button
            label="Yes"
            severity="danger"
            onClick={handleDelete}
            autoFocus
            style={{
              minWidth: "60px",
              borderRadius: "8px",
            }}
          />
        </DialogActions>

          </div>
        </Dialog>

        {/* ================= EMPTY FIELD ERROR ================= */}
        <Dialog open={errorpopup}>
          <div className="learnrkb-popup-one">
            <div className="CreateReport-Close">
              <i
                className="pi pi-times"
                onClick={() => setErrorpopup(false)}
                style={{ color: "#697565", cursor: "pointer" }}
              />
            </div>
            <div className="CreateReport_Page">
              <h1>Empty Field</h1>
              <p>Please fill all the required fields.</p>
            </div>
          </div>
        </Dialog>

        {sessionExpired && <SessionLogout />}

    </div>
  );
};

export default LearnRkbHome;
